import React, { useState, useEffect, useContext } from "react";
import { UserContext, ShowContext } from "../../App";
import API from "../../API";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import MenuSortModal from "./MenuSortModal";

function MenuTable({ list, setList, edit, setEdit, editValues, setEditValues, getMenu }) {
  const { currentUser } = useContext(UserContext);
  const { setShow, setMsg } = useContext(ShowContext);
  const [header, setHeader] = useState();
  const [data, setData] = useState();
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);

  useEffect(() => {
    if (list) {
      setHeader(getHeader());
      setData(getData(list, setShow, setMsg, setList, edit, setEdit, editValues, setEditValues));
    }
  }, [list, edit]);

  async function saveOrder(flattenedData) {
    const orderedItems = flattenedData.map((item, index) => ({
      id: item.id,
      order_id: item.order_id,
    }));

    await API.post("/homemenu/reorder", { items: orderedItems })
      .then((res) => {
        if (res.data.status === "success") {
          setShow(true);
          setMsg(res.data.message);
          getMenu(setList, 1);
        }
      })
      .catch((error) => {
        setShow(true);
        setMsg(error.response?.data?.message || "Error saving order");
      });
  }

  return currentUser && data ? (
    <>
      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="m-0">Menu List</h4>
          <button className="btn btn-primary" onClick={() => setIsSortModalOpen(true)}>
            Sort Menu Tree
          </button>
        </div>
        <div style={{ overflowX: "scroll" }}>
          <BootstrapTable
            keyField="srno"
            data={data}
            columns={header}
            headerClasses="allTable_header text-center"
            pagination={paginationFactory()}
          />
        </div>
      </div>

      <MenuSortModal isOpen={isSortModalOpen} onClose={() => setIsSortModalOpen(false)} list={list} onSave={saveOrder} />
    </>
  ) : null;

  function getHeader() {
    let myHeader = [
      { text: "Sr.No.", dataField: "srno", headerStyle: { width: "80px" } },
      // { text: "Order", dataField: "order", headerStyle: { width: '100px' } },
      { text: "Title", dataField: "title" },
      { text: "Url", dataField: "url" },
      { text: "Parent", dataField: "parent" },
      { text: "Edit", dataField: "edit", headerStyle: { width: "100px" } },
      { text: "Status", dataField: "status", headerStyle: { width: "100px" } },
    ];
    return myHeader;
  }

  function getData(list, setShow, setMsg, setList, edit, setEdit, editValues, setEditValues) {
    let myData = [];
    let i = 1;
    if (list !== undefined && list?.data?.length > 0) {
      list?.data?.forEach((data, index) => {
        myData.push({
          srno: i++,
          order: (
            <input
              type="number"
              className="form-control text-center"
              defaultValue={data.order_id}
              style={{ width: "70px" }}
              onBlur={(e) => {
                const newOrder = parseFloat(e.target.value);
                if (newOrder !== data.order_id) {
                  saveOrder([{ id: data.id, order_id: newOrder }]);
                }
              }}
            />
          ),
          title: data.title,
          url: data.menu_url,
          parent: data.parent?.title || "None",
          edit: (
            <center>
              <button
                className="btn btn-warning"
                onClick={() => {
                  setEdit(true);
                  setEditValues(data);
                }}
                disabled={edit}
              >
                Edit
              </button>
            </center>
          ),
          status: (
            <center>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={parseInt(data.status)}
                  onChange={() => {
                    updateStatus(data.id, parseInt(data.status) ? 0 : 1, setShow, setMsg, list, setList);
                  }}
                />
                <span className="slider round"></span>
              </label>
            </center>
          ),
        });
      });
    }
    return myData;
  }

  async function updateStatus(id, status, setShow, setMsg, list, setList) {
    await API.post("/homemenu/disable", { id: id, status: status })
      .then((res) => {
        if (res.data.status === "success") {
          setList((pre) => ({
            ...pre,
            data: pre.data.map((rec) => {
              if (rec.id != id) {
                return rec;
              } else {
                return { ...rec, status: parseInt(rec.status) ? 0 : 1 };
              }
            }),
          }));
          setShow(true);
          setMsg(res.data.message);
        }
      })
      .catch((error) => {
        setShow(true);
        setMsg(error.response?.data?.message || "Error updating status");
      });
  }
}

export default MenuTable;
